export const COURSE_TOKEN_KEY = 'courseStudentToken';

export const COURSE_CATEGORIES = {
  BREEDER: 'breeder',
  DOCTOR_ENGINEER: 'doctor_engineer',
  STUDENT: 'student',
  STUDENT_GROUP: 'student_group',
};

export const CATEGORY_PRICES = {
  breeder: 995,
  doctor_engineer: 895,
  student: 495,
  student_group: 2000,
};

export const CATEGORY_LABELS = {
  breeder: { en: 'Breeder', ar: 'مربي', ur: 'بریڈر' },
  doctor_engineer: { en: 'Doctor / Engineer', ar: 'دكتور / مهندس', ur: 'ڈاکٹر / انجینئر' },
  student: { en: 'Student', ar: 'طالب', ur: 'طالب علم' },
  student_group: { en: 'Group of 5 Students', ar: 'مجموعة 5 طلاب', ur: '5 طلبہ کی گروپ' },
};

export const DOCUMENT_LABELS = {
  breeder: {
    en: 'Upload National ID Card',
    ar: 'رفع بطاقة الرقم القومي',
    ur: 'قومی شناختی کارڈ اپ لوڈ کریں',
  },
  doctor_engineer: {
    en: 'Upload Syndicate Card, Employment Card, or Professional ID',
    ar: 'رفع بطاقة النقابة أو بطاقة العمل أو الهوية المهنية',
    ur: 'سندیکیٹ کارڈ، ملازمت کارڈ یا پیشہ ورانہ آئی ڈی اپ لوڈ کریں',
  },
  student: {
    en: 'Upload Student ID Card',
    ar: 'رفع بطاقة الطالب',
    ur: 'طالب علم کارڈ اپ لوڈ کریں',
  },
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PENDING_REVIEW: 'pending_review',
  PAID: 'paid',
  REJECTED: 'rejected',
  FAILED: 'failed',
  EXPIRED: 'expired',
  REFUNDED: 'refunded',
};

export const REGISTRATION_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  PENDING_REVIEW: 'pending_review',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const PAYMENT_METHODS = {
  PAYMOB: 'paymob',
  PAYMOB_KIOSK: 'paymob_kiosk',
  INSTAPAY: 'instapay',
  FAWRY: 'fawry',
  BANK_TRANSFER: 'bank_transfer',
  MANUAL_RECEIPT: 'manual_receipt',
};

/** Backend may expose kiosk under several keys — including legacy `fawry`. */
export const PAYMOB_KIOSK_METHOD_KEYS = [
  PAYMENT_METHODS.PAYMOB_KIOSK,
  PAYMENT_METHODS.FAWRY,
  'kiosk',
  'paymob_cash',
  'fawry_kiosk',
  'cash',
];


export const LECTURE_PLATFORMS = [
  'zoom',
  'google_meet',
  'microsoft_teams',
  'recorded_video',
  'google_drive',
  'other',
];

export const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
export const ACCEPTED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf'];
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB

export const EGYPTIAN_PHONE_REGEX = /^(01)[0-2,5]{1}[0-9]{8}$/;
